import React, {useEffect, useState} from "react";
import MessageTestDetail from "./MessageTestDetail";
import AppointmentRequest from "./AppointmentRequest";
import MessageReplyChain from "./MessageReplyChain"

const MessageReply = (props) => {
    const message = props.message;
    const [component, setComponent] = useState(null);
    const messageUUID = props.messageUUID;

    // useEffect(() => {
    //     if (messageUUID) {
    //         async function getMessage() {
    //             try {
    //                 const getMessage = await ApiService.getMessage(messageUUID);
    //                 setMessage(getMessage.data);
    //             } catch(ex) {
    //                 console.error(ex);
    //             }
    //         }
    //         getMessage();
    //     }
    // }, []);

    useEffect(() => {
        if (message) {
            if (message.messageType === "TEST_RESULT") {
                setComponent(<MessageTestDetail message={message} messageUUID={messageUUID}/>);
            } else if (message.messageType === "APPOINTMENT_REQUEST") {
                setComponent(<AppointmentRequest message={message} messageUUID={messageUUID}/>);
            } else if (message.messageType === "MESSAGE") {
                setComponent(<MessageReplyChain message={message} messageUUID={messageUUID}/>);
            } else if (message.messageType === "BELUGA") {
                setComponent(<MessageReplyChain message={message} messageUUID={messageUUID}/>);
            } else {
                setComponent(<MessageReplyChain message={message} messageUUID={messageUUID}/>);
            }
        }
    }, [message]);

    if (!component) {
        return (<div className="msg_container"></div>)
    } else {
        return (
            <div className="msg_container">
                {component}
            </div>
        )
    }
}

export default MessageReply;